var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sp-language-summary"},[(_vm.visibleCodes.length)?_c('span',[_vm._v(_vm._s(_vm.visibleCodes.join(', ')))]):_c('span',[_vm._v("No lead languages")]),(_vm.remainingCount)?_c('span',{staticClass:"sp-language-summary__more"},[_vm._v("+"+_vm._s(_vm.remainingCount))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }